// sort without modifying the original array

interface Comparator<E> {
    (prev: E, next: E): number;
}

export const sortArray = <T>(array: Array<T>, comparator: Comparator<T>) => [...array].sort(comparator);
